// Generated by scripts/mdi/import-questionnaires.mjs from MDI "CJC-1295 / Ipamorelin 09.17.26" (2f292cd1-559d-4a54-8f80-cbbf17d69703). Re-run instead of editing.
import { QuestionAnswerMap } from '@care-portals/api-interfaces';

const mdiCJC1295IpamorelinQuestions = [
  {
    field: 'mdiCJC1295Ipamorelin_sex',
    label: 'What was your sex assigned at birth?',
    type: 'select',
    extras: { sendToBeluga: false, sendToMdi: false, mdiRouting: true },
    answer: {
      type: 'single_select',
      options: [
        { key: 'male', value: 'Male' },
        { key: 'female', value: 'Female' }
      ]
    }
  },
  {
    field: 'mdiCJC1295Ipamorelin_pregnancy',
    label: 'Are you currently pregnant?',
    type: 'select',
    extras: { sendToBeluga: false, mdiRouting: true },
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' }
      ]
    }
  },
  {
    field: 'mdiCJC1295Ipamorelin_breastfeeding',
    label: 'Are you currently breastfeeding?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'no', value: 'No' },
        { key: 'yes', value: 'Yes' }
      ]
    },
    extras: { mdiQuestionId: '09efcc5d-5bce-4506-90bc-6f14de62d8ad' }
  },
  {
    field: 'mdiCJC1295Ipamorelin_wereSorryTreatmentNotMedically',
    label:
      "We're sorry, this treatment is not medically appropriate for you at this time.",
    type: 'info',
    answer: {},
    class: 'ineligible',
    reject: true,
    blockQuestionFlow: true,
    isLast: true,
    extras: {
      mdiQuestionId: '07b20799-c793-48b4-a8bf-cc026ad1f868',
      sendToBeluga: false,
      sendToMdi: false
    }
  },
  {
    field: 'mdiCJC1295Ipamorelin_importantClickAttachedLinkReview',
    label:
      'IMPORTANT: Please click the attached link to review the consent for your peptide therapy treatment plan. By typing your name into the signature field you are attesting that you have read and understand this consent in its entirety.',
    type: 'info',
    subLabel:
      'Please click this link to view the Peptide therapy consent (https://drive.google.com/file/d/1eA855MyEZYOQFYuJq3_GSUYm0cK5CGOn/view)',
    answer: {
      type: 'text',
      name: 'mdiCJC1295Ipamorelin_importantClickAttachedLinkReview',
      placeholder: 'Type your full legal name to proceed'
    },
    extras: { mdiQuestionId: '5ec099af-0c23-4a38-96b5-21ca71c64067' }
  },
  {
    field: 'mdiCJC1295Ipamorelin_reasonInterestedPeptide',
    label: 'What is the reason you are interested in this peptide?',
    type: 'select',
    educationalSlide: 'Select all that apply',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'support_the_bodys_natural_release_of_gro',
          value: 'Support the body’s natural release of growth hormone'
        },
        {
          key: 'building_or_maintaining_muscle_mass',
          value: 'Building or maintaining muscle mass'
        },
        {
          key: 'weight_loss_fat_reduction_and_improved_b',
          value: 'Weight loss/fat reduction and improved body composition'
        },
        { key: 'improved_sleep_quality', value: 'Improved sleep quality' },
        {
          key: 'improved_quality_of_hair_skin_nails',
          value: 'Improved quality of hair/skin/nails'
        },
        {
          key: 'improve_daily_energy_fatigue',
          value: 'Improve daily energy/fatigue'
        },
        {
          key: 'general_longevity_and_potential_anti_agi',
          value: 'General longevity and potential anti-aging benefits'
        },
        {
          key: 'muscle_recovery_and_lean_muscle_mass_pre',
          value: 'Muscle recovery and lean muscle mass preservation'
        },
        {
          key: 'body_composition_optimization_increased',
          value:
            'Body composition optimization (increased lean mass, decreased body fat)'
        },
        {
          key: 'bone_density_support_and_fracture_healin',
          value: 'Bone density support and fracture healing'
        },
        {
          key: 'skin_quality_and_elasticity_improvement',
          value: 'Skin quality and elasticity improvement (anti-aging)'
        },
        {
          key: 'sleep_quality_enhancement',
          value: 'Sleep quality enhancement'
        },
        {
          key: 'tissue_repair_and_post_surgical_recovery',
          value: 'Tissue repair and post-surgical recovery'
        },
        {
          key: 'joint_and_connective_tissue_health',
          value: 'Joint and connective tissue health'
        },
        {
          key: 'metabolic_optimization_and_fat_loss',
          value: 'Metabolic optimization and fat loss'
        },
        {
          key: 'age_related_growth_hormone_decline',
          value: 'Age-related growth hormone decline'
        },
        {
          key: 'athletic_performance_and_recovery_suppor',
          value: 'Athletic performance and recovery support'
        },
        {
          key: 'general_wellness_and_vitality_optimizati',
          value: 'General wellness and vitality optimization'
        },
        {
          key: 'other_please_specify',
          value: 'Other (please specify)',
          answer: {
            type: 'text',
            name: 'other_please_specify_details',
            placeholder: 'Please specify'
          }
        }
      ]
    },
    extras: { mdiQuestionId: '3349bf5f-6d13-44ed-b3d6-aec17e6fece6' }
  },
  {
    field: 'mdiCJC1295Ipamorelin_everUsedPeptideTherapiesPast',
    label: 'Have you ever used peptide therapies in the past?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' }
      ]
    },
    extras: { mdiQuestionId: '5749d2ca-dc5f-4f04-a2fd-9aa5993a33f1' }
  },
  {
    field: 'mdiCJC1295Ipamorelin_peptidesUsedPreviously',
    label: 'What peptides have you used previously?',
    type: 'info',
    answer: {
      type: 'text',
      name: 'mdiCJC1295Ipamorelin_peptidesUsedPreviously',
      rows: 4
    },
    extras: { mdiQuestionId: '0306f318-8da5-49a0-8df8-1eb4e6ff248c' }
  },
  {
    field: 'mdiCJC1295Ipamorelin_everReactionSideEffectsPeptide',
    label:
      'Have you ever had a reaction or side effects to peptide therapies in the past?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' }
      ]
    },
    extras: { mdiQuestionId: '2f39aed7-41a9-44f9-91e8-3e63fb99d11b' }
  },
  {
    field: 'mdiCJC1295Ipamorelin_reactionSideEffect',
    label: 'What was your reaction or side effect?',
    type: 'info',
    answer: {
      type: 'text',
      name: 'mdiCJC1295Ipamorelin_reactionSideEffect',
      rows: 4
    },
    extras: { mdiQuestionId: '046b790d-d0b0-4893-b0e3-739274e357b7' }
  },
  {
    field: 'mdiCJC1295Ipamorelin_diagnosedRedFlagMedicalConditions',
    label:
      'Do you currently have or have you been diagnosed with any of the following red flag medical conditions listed below that may disqualify you from treatment?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'cancer', value: 'Cancer' },
        {
          key: 'significant_cardiovascular_disease_such',
          value:
            'Significant cardiovascular disease such as heart attack, stroke, etc'
        },
        {
          key: 'uncontrolled_high_blood_pressure',
          value: 'Uncontrolled high blood pressure'
        },
        {
          key: 'poorly_controlled_diabetes',
          value: 'Poorly controlled diabetes'
        },
        { key: 'insulin_resistance', value: 'Insulin-resistance' },
        { key: 'kidney_disease', value: 'Kidney disease' },
        { key: 'liver_disease', value: 'Liver disease' },
        {
          key: 'pituitary_or_hypothalamic_disorder',
          value: 'Pituitary or hypothalamic disorder'
        },
        {
          key: 'history_of_pancreatitis_or_pancreatic_di',
          value: 'History of pancreatitis or pancreatic disease'
        },
        { key: 'autoimmune_disease', value: 'Autoimmune disease' },
        { key: 'uncontrolled_diabetes', value: 'Uncontrolled diabetes' },
        { key: 'retinopathy', value: 'Retinopathy' },
        { key: 'peripheral_edema', value: 'Peripheral edema' },
        { key: 'thyroid_disease', value: 'Thyroid disease' },
        {
          key: 'sleep_apnea_chronic_respiratory_conditio',
          value: 'Sleep apnea/chronic respiratory conditions'
        },
        {
          key: 'pituitary_brain_or_intracranial_tumors',
          value: 'Pituitary, brain or intracranial tumors'
        },
        {
          key: 'uncontrolled_intracranial_hypertension',
          value: 'Uncontrolled intracranial hypertension'
        },
        {
          key: 'other_please_specify',
          value: 'Other (please specify)',
          answer: {
            type: 'text',
            name: 'other_please_specify_details',
            placeholder: 'Please specify'
          }
        },
        { key: 'none_of_these_apply_to_me', value: 'None of these apply to me' }
      ]
    },
    extras: { mdiQuestionId: 'db4bf049-e031-4be7-abab-3d733173df0c' }
  },
  {
    field: 'mdiCJC1295Ipamorelin_confirmNotHistoryCancerKidney',
    label:
      'Please confirm you do not have any history of cancer, kidney or liver disease:',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'i_agree_i_do_not_have_any_history_of_can',
          value:
            'I agree, I do NOT have any history of cancer, kidney or liver disease'
        },
        {
          key: 'i_have_been_diagnosed_with_cancer_or_hav',
          value:
            'I HAVE been diagnosed with cancer or have had problems with my kidneys or liver previously'
        }
      ]
    },
    extras: { mdiQuestionId: '854c8c21-8366-4e43-b823-304abbf9f145' }
  },
  {
    field: 'mdiCJC1295Ipamorelin_takeRedFlagMedicationsSubstances',
    label:
      'Do you take any of the following red flag medications or substances that may disqualify you from treatment?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'growth_hormone_peptides_or_medications',
          value: 'Growth hormone peptides or medications'
        },
        { key: 'corticosteroids', value: 'Corticosteroids' },
        {
          key: 'diabetes_medication_or_insulin',
          value: 'Diabetes medication or insulin'
        },
        {
          key: 'levothyroxine_liothyronine_or_thyroid_me',
          value: 'Levothyroxine, liothyronine or thyroid medications'
        },
        {
          key: 'hormone_replacement_therapy',
          value: 'Hormone replacement therapy'
        },
        {
          key: 'stimulants_such_as_caffeine_pre_workout',
          value:
            'Stimulants such as caffeine, pre-workout, amphetamines or ADHD medication, etc'
        },
        { key: 'octreotide_or_lanreotide', value: 'Octreotide or lanreotide' },
        {
          key: 'glucocorticoids_prednisone_methylprednis',
          value:
            'Glucocorticoids (prednisone, methylprednisolone, dexamethasone, etc)'
        },
        { key: 'glp1_agonists', value: 'GLP1 agonists' },
        { key: 'clonidine', value: 'Clonidine' },
        { key: 'levodopa', value: 'Levodopa' },
        {
          key: 'cox_inhibitors_ibuprofen_naproxen_etc',
          value: 'COX inhibitors (ibuprofen, naproxen, etc)'
        },
        {
          key: 'alcohol_use_heavy_drinking',
          value: 'Alcohol use (heavy drinking)'
        },
        { key: 'opioid_use', value: 'Opioid use' },
        { key: 'none_of_the_above', value: 'None of the above' }
      ]
    },
    extras: { mdiQuestionId: '33d5a793-1638-4aff-aff4-083abbc2b7b0' }
  },
  {
    field: 'mdiCJC1295Ipamorelin_allergyBenzylPeroxide',
    label: 'Do you have an allergy to benzyl peroxide?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'no', value: 'No' },
        { key: 'yes', value: 'Yes' }
      ]
    },
    extras: { mdiQuestionId: '562f2af2-65cc-4cae-be5e-166f2153de73' }
  },
  {
    field: 'mdiCJC1295Ipamorelin_lastTimePersonMedicalEvaluation',
    label: 'When was the last time you had an in-person medical evaluation?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'less_than_a_year_ago', value: 'Less than a year ago' },
        { key: 'o_1_2_years_ago', value: '1-2 years ago' },
        { key: 'more_than_2_years_ago', value: 'More than 2 years ago' }
      ]
    },
    extras: { mdiQuestionId: '6268679e-1ef7-4200-98b4-872c9727ba87' }
  },
  {
    field: 'mdiCJC1295Ipamorelin_confirmUnderstandContactDoctorQuestions',
    label:
      'Please confirm the following: I understand and will contact my doctor if I have any questions',
    type: 'info',
    subLabel:
      'I understand that this peptide therapy is for use as a subcutaneous injection. I understand I will have to draw up and administer this injection myself. I understand that administering incorrectly or the wrong amount of this peptide therapy may cause serious side effects. I agree that I will reach out to my doctor prior to administering if I have any questions so that I can do it correctly\n\nType your full legal name below:',
    answer: {
      type: 'text',
      name: 'mdiCJC1295Ipamorelin_confirmUnderstandContactDoctorQuestions'
    },
    extras: { mdiQuestionId: '18269db2-816f-49a9-9298-8355b2b78a28' }
  },
  {
    field: 'mdiCJC1295Ipamorelin_firstMessageDoctor',
    label: 'This is your first message to your doctor.',
    type: 'info',
    subLabel:
      'Feel free to introduce yourself, ask any questions, or list any concerns you may have.',
    answer: {
      type: 'text',
      name: 'mdiCJC1295Ipamorelin_firstMessageDoctor',
      rows: 4
    },
    extras: { mdiQuestionId: '676c2fc3-bf9d-4e74-aa20-44c8345bb9a6' }
  },
  {
    field: 'mdiCJC1295Ipamorelin_complete',
    label:
      'Thank you for completing this questionnaire, please select "Finish" to submit',
    type: 'info',
    isLast: true,
    answer: {},
    extras: { sendToBeluga: false, sendToMdi: false }
  }
] as const;

export type mdiCJC1295IpamorelinAnswerField = Partial<
  QuestionAnswerMap<typeof mdiCJC1295IpamorelinQuestions>
>;

export default mdiCJC1295IpamorelinQuestions;
